import type {LegacyButtonProps as ButtonProps} from './lib-button';
import type {LocationType, RerouterLocation} from 'src/rerouter/types';

import * as React from 'react';
import {Link} from 'src/rerouter';

import classify from 'src/utils/classify';

import css from './button.css';

// TODO (kyle): there has to be a good way to share more code with
// Button.
export function LinkButton({
  type = 'default',
  size = 'small',
  round,
  styleDisabled,
  icon,
  className,
  children,
  ...props
}: ButtonProps & {
  className?: string;
  children?: React.ReactNode;
  to?: LocationType | ((location: RerouterLocation) => LocationType) | null;
  activeClassName?: string;
  onlyActiveOnIndex?: boolean;
  target?: string | null;
  handleExtension?: boolean;
}) {
  return (
    <Link
      {...props}
      className={classify(className, css.buttonText, css[type], css[size], {
        [css.buttonIcon]: icon,
        [css.buttonEnabled]: true,
        [css.buttonDisabled]: styleDisabled,
        [css.buttonRound]: round,
      })}
    >
      {icon && <div className={css.icon}>{icon}</div>}
      <span className={css.children}>{children}</span>
    </Link>
  );
}
